import { useCallback, useRef, useState } from 'react';

export default function useDebounce<T>(
  value: T,
  delay: number = 1000
): [T, (value: T) => void, (v: T) => void] {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  const debouncedSetValue = useCallback(
    (value: T) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
    },
    [delay]
  );

  const updateImmediate = useCallback((v: T) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setDebouncedValue(v);
  }, []);

  return [debouncedValue, debouncedSetValue, updateImmediate];
}
